module.exports = __webpack_public_path__ + "img/fill.12fd60f3.svg";